import HomeContainer from "../../HomeContainer/HomeContainer";
import "./ProductTabsSkeleton.css";

export default function ProductTabsSkeleton({
  productCount = 4,
  tabCount = 4,
}) {
  return (
    <HomeContainer>
      <section className="amazing-offers amazing-offers-skeleton">

        {/* Left banner */}
        <div className="offer-banner">
          <div className="skeleton-offer-text" />
          <div className="skeleton-offer-image" />
        </div>

        {/* Right side */}
        <div className="offer-slider">

          {/* Tabs */}
          <div className="skeleton-tabs">
            {Array.from({ length: tabCount }).map((_, index) => (
              <div
                key={index}
                className="skeleton-tab"
              />
            ))}
          </div>

          {/* Products */}
          <div className="skeleton-products">
            {Array.from({ length: productCount }).map((_, index) => (
              <div
                key={index}
                className="skeleton-product"
              >
                <div className="skeleton-product__image" />

                <div className="skeleton-product__title">
                  <span />
                  <span />
                </div>

                <div className="skeleton-product__price" />

                <div className="skeleton-product__bottom">
                  <span />
                  <span />
                </div>
              </div>
            ))}
          </div>

        </div>
      </section>
    </HomeContainer>
  );
}